import React from "react"
import PropTypes from "prop-types"

const LinesComponent = (props) => {
  return (
    <React.Fragment>
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={722}
        height={687}
        fill="none"
        {...props}
      >
        <path
          fill="#000"
          fillOpacity={0.12}
          d="M-10 666.948c0 5.523 4.477 10 10 10h90c5.523 0 10-4.477 10-10s-4.477-10-10-10H10v-80c0-5.523-4.477-10-10-10s-10 4.477-10 10v90Zm17.071 7.071L181.02 500.071l-14.142-14.142L-7.071 659.877 7.07 674.019Z"
        />
        <path
          fill="#7AD9AD"
          d="M323.855 478.757c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10v-80h-80c-5.522 0-10-4.477-10-10s4.478-10 10-10h90Zm7.072 17.071L156.978 669.777l-14.142-14.143 173.948-173.948 14.143 14.142Z"
        />
        <path
          fill="#000"
          fillOpacity={0.12}
          d="M86 392.948c0 5.523 4.477 10 10 10h90c5.523 0 10-4.477 10-10s-4.477-10-10-10h-80v-80c0-5.523-4.477-10-10-10s-10 4.477-10 10v90Zm17.071 7.071 173.948-173.948-14.142-14.142L88.929 385.877l14.142 14.142ZM419.855 204.757c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10v-80h-80c-5.522 0-10-4.477-10-10s4.478-10 10-10h90Zm7.072 17.071L252.978 395.777l-14.142-14.143 173.948-173.948 14.143 14.142ZM378 449.948c0 5.523 4.477 10 10 10h90c5.523 0 10-4.477 10-10s-4.477-10-10-10h-80v-80c0-5.523-4.477-10-10-10s-10 4.477-10 10v90Zm17.071 7.071 173.948-173.948-14.142-14.142-173.948 173.948 14.142 14.142ZM711.855 261.757c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10v-80h-80c-5.522 0-10-4.477-10-10s4.478-10 10-10h90Zm7.072 17.071L544.978 452.777l-14.142-14.143 173.948-173.948 14.143 14.142Z"
        />
        <path
          fill="#7AD9AD"
          d="M451 181.948c0 5.523 4.477 10 10 10h90c5.523 0 10-4.477 10-10s-4.477-10-10-10h-80v-80c0-5.523-4.477-10-10-10s-10 4.477-10 10v90Zm17.071 7.071L642.019 15.071 627.877.93 453.929 174.877l14.142 14.142Z"
        />
        <path
          fill="#000"
          fillOpacity={0.12}
          d="M316 727.948c0 5.523 4.477 10 10 10h90c5.523 0 10-4.477 10-10s-4.477-10-10-10h-80v-80c0-5.523-4.477-10-10-10s-10 4.477-10 10v90Zm17.071 7.071 173.948-173.948-14.142-14.142-173.948 173.948 14.142 14.142ZM649.855 539.757c5.523 0 10 4.477 10 10v90c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10v-80h-80c-5.522 0-10-4.477-10-10s4.478-10 10-10h90Zm7.072 17.071L482.978 730.777l-14.142-14.143 173.948-173.948 14.143 14.142Z"
        />
        <g filter="url(#a)">
          <circle cx={205} cy={585.925} r={51} fill="#fff" />
        </g>
        <g clipPath="url(#b)">
          <path
            fill="#2775CA"
            d="M205.5 620.925a35.415 35.415 0 0 0 35.5-35.5 35.415 35.415 0 0 0-35.5-35.5 35.415 35.415 0 0 0-35.5 35.5 35.415 35.415 0 0 0 35.5 35.5Z"
          />
          <path
            fill="#fff"
            d="M215.262 591.046c0-5.177-3.106-6.952-9.319-7.691-4.437-.592-5.325-1.775-5.325-3.846 0-2.072 1.48-3.402 4.438-3.402 2.662 0 4.142.887 4.881 3.106.148.444.592.739 1.036.739h2.366a1.01 1.01 0 0 0 1.036-1.035v-.148a7.39 7.39 0 0 0-6.657-6.064v-3.55c0-.592-.443-1.036-1.183-1.184h-2.219c-.591 0-1.035.444-1.183 1.184v3.402c-4.438.591-7.248 3.55-7.248 7.248 0 4.881 2.958 6.804 9.171 7.543 4.142.74 5.473 1.627 5.473 3.994s-2.071 3.994-4.881 3.994c-3.846 0-5.178-1.627-5.621-3.846-.148-.592-.592-.888-1.036-.888h-2.514c-.592 0-1.036.444-1.036 1.036v.148c.592 3.698 2.959 6.36 7.84 7.1v3.55c0 .591.444 1.035 1.183 1.183h2.219c.592 0 1.035-.444 1.183-1.183v-3.55c4.438-.74 7.396-3.846 7.396-7.84Z"
          />
          <path
            fill="#fff"
            d="M197.956 606.577c-11.537-4.141-17.454-17.01-13.164-28.4 2.218-6.212 7.1-10.945 13.164-13.164.592-.296.888-.74.888-1.479v-2.071c0-.592-.296-1.036-.888-1.183-.148 0-.444 0-.592.147-14.052 4.438-21.743 19.378-17.306 33.43 2.663 8.283 9.023 14.643 17.306 17.306.592.296 1.184 0 1.332-.592.148-.148.148-.296.148-.591v-2.071c0-.444-.444-1.036-.888-1.332Zm15.679-46.15c-.591-.295-1.183 0-1.331.592-.148.148-.148.296-.148.592v2.071c0 .591.444 1.183.888 1.479 11.537 4.141 17.454 17.01 13.164 28.4-2.219 6.212-7.1 10.946-13.164 13.164-.592.296-.888.74-.888 1.48v2.07c0 .592.296 1.036.888 1.184.148 0 .443 0 .591-.148 14.052-4.438 21.744-19.377 17.307-33.429-2.663-8.432-9.171-14.792-17.307-17.455Z"
          />
        </g>
        <g filter="url(#c)">
          <circle cx={461} cy={269.925} r={51} fill="#fff" />
        </g>
        <g fillRule="evenodd" clipPath="url(#d)" clipRule="evenodd">
          <path
            fill="#50AF95"
            d="m440.268 246.21-12.217 25.536a.497.497 0 0 0 .107.578l32.993 31.462a.508.508 0 0 0 .697 0l32.994-31.46a.497.497 0 0 0 .107-.578l-12.217-25.536a.493.493 0 0 0-.45-.287h-41.56a.495.495 0 0 0-.454.285Z"
          />
          <path
            fill="#fff"
            d="M465.739 274.368c-.237.018-1.461.091-4.191.091-2.171 0-3.713-.065-4.254-.091-8.391-.367-14.654-1.82-14.654-3.561 0-1.74 6.263-3.192 14.654-3.565v5.679c.549.039 2.12.131 4.292.131 2.605 0 3.91-.108 4.145-.129v-5.677c8.373.371 14.622 1.825 14.622 3.561 0 1.737-6.247 3.19-14.622 3.559l.008.002Zm0-7.709v-5.082h11.685v-7.749h-31.815v7.749h11.683v5.08c-9.496.434-16.638 2.306-16.638 4.549 0 2.243 7.142 4.113 16.638 4.549v16.284h8.445v-16.29c9.474-.434 16.604-2.304 16.604-4.545s-7.124-4.111-16.604-4.547l.002.002Z"
          />
        </g>
        <g filter="url(#e)">
          <circle cx={270} cy={293.925} r={51} fill="#fff" />
        </g>
        <path
          fill="#343434"
          d="m270.494 257.925-.492 1.67v48.458l.492.49 22.492-13.296-22.492-37.322Z"
        />
        <path
          fill="#8C8C8C"
          d="M270.493 257.925 248 295.247l22.493 13.296V257.925Z"
        />
        <path
          fill="#3C3C3B"
          d="m270.493 312.802-.277.338v17.261l.277.809L293 299.513l-22.507 13.289Z"
        />
        <path
          fill="#8C8C8C"
          d="M270.493 331.21v-18.408L248 299.513l22.493 31.697Z"
        />
        <path
          fill="#141414"
          d="m270.493 308.543 22.493-13.296-22.493-10.224v23.52Z"
        />
        <path fill="#393939" d="m248 295.247 22.493 13.296v-23.52L248 295.247Z" />
        <g filter="url(#f)">
          <circle cx={388} cy={441.925} r={51} fill="#fff" />
        </g>
        <path
          fill="#F7931A"
          d="M421.953 451.397c-4.675 18.752-23.668 30.164-42.423 25.488-18.746-4.675-30.159-23.669-25.482-42.42 4.673-18.754 23.666-30.167 42.415-25.492 18.753 4.675 30.165 23.671 25.489 42.424h.001Z"
        />
        <path
          fill="#fff"
          d="M403.435 437.942c.697-4.658-2.849-7.162-7.699-8.833l1.573-6.31-3.841-.957-1.531 6.144c-1.01-.252-2.047-.489-3.078-.724l1.543-6.185-3.839-.957-1.574 6.308c-.836-.19-1.656-.378-2.453-.576l.005-.02-5.297-1.323-1.022 4.103s2.85.653 2.79.693c1.555.388 1.836 1.418 1.79 2.234l-1.792 7.189c.107.027.246.066.399.128-.128-.032-.265-.067-.406-.101l-2.512 10.071c-.19.472-.672 1.181-1.76.912.039.056-2.792-.697-2.792-.697l-1.907 4.397 4.999 1.246c.93.233 1.841.477 2.738.707l-1.589 6.382 3.837.957 1.574-6.314c1.048.284 2.065.547 3.061.794l-1.569 6.285 3.841.957 1.59-6.37c6.549 1.239 11.474.74 13.547-5.185 1.671-4.77-.083-7.521-3.529-9.315 2.51-.579 4.401-2.23 4.905-5.639l-.002-.001Zm-8.776 12.306c-1.187 4.77-9.218 2.192-11.821 1.545l2.109-8.455c2.603.65 10.953 1.936 9.712 6.91Zm1.188-12.375c-1.083 4.339-7.767 2.134-9.935 1.594l1.912-7.669c2.168.541 9.151 1.549 8.024 6.075h-.001Z"
        />
        <g filter="url(#g)">
          <circle cx={542} cy={589.925} r={51} fill="#fff" />
        </g>
        <path
          fill="#E2761B"
          stroke="#E2761B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m572 559.925-26 19 4.808-11.209L572 559.925Z"
        />
        <path
          fill="#E4761B"
          stroke="#E4761B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m513.637 559.925 24.783 19.019-4.394-11.294-20.389-7.725Zm48.687 43.672-6.654 10.351 14.237 3.977L574 603.827l-11.676-.23Zm-51.324.23 4.068 14.098 14.237-3.977-6.654-10.351-11.651.23Z"
        />
        <path
          fill="#E4761B"
          stroke="#E4761B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M528.088 585.867 524 592.008l14.567.642-.517-15.545-9.962 8.762Zm28.798 0-10.091-8.942-.336 15.725 14.541-.642-4.114-6.141Zm-27.97 28.058 8.746-4.239-7.556-5.859-1.19 10.098Zm18.397-4.239 8.771 4.239-1.216-10.098-7.555 5.859Z"
        />
        <path
          fill="#D7C1B3"
          stroke="#D7C1B3"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m556 614.129-8.717-4.204.694 5.631-.077 2.369 8.1-3.796Zm-27 0 8.1 3.796-.051-2.369.642-5.631-8.691 4.204Z"
        />
        <path
          fill="#233447"
          stroke="#233447"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M537.238 599.925 530 598.017l5.108-2.092 2.13 4Zm10.498 0 2.131-4 5.133 2.092-7.264 1.908Z"
        />
        <path
          fill="#CD6116"
          stroke="#CD6116"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m528.877 613.925 1.245-10.471-8.122.232 6.877 10.239Zm26.001-10.471 1.245 10.471L563 603.686l-8.122-.232Zm6.176-11.529-14.584.645 1.35 7.454 2.153-4.488 5.19 2.347 5.891-5.958Zm-31.191 5.958 5.19-2.347 2.127 4.488 1.376-7.454-14.61-.645 5.917 5.958Z"
        />
        <path
          fill="#E4751F"
          stroke="#E4751F"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m524 591.925 6.106 11.939-.207-5.943-5.899-5.996Zm31.127 5.996-.259 5.943L561 591.925l-5.873 5.996Zm-16.56-5.347-1.371 7.501 1.707 8.85.389-11.653-.725-4.698Zm7.892 0-.699 4.672.311 11.679 1.733-8.85-1.345-7.501Z"
        />
        <path
          fill="#F6851B"
          stroke="#F6851B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m547.744 600.105-1.718 8.954 1.23.866 7.488-5.987.256-6.013-7.256 2.18ZM530 597.925l.205 6.013 7.487 5.987 1.231-.866-1.692-8.954-7.231-2.18Z"
        />
        <path
          fill="#C0AD9E"
          stroke="#C0AD9E"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m547.9 617.574.077-2.277-.643-.539h-9.694l-.591.539.051 2.277-8.1-3.649 2.829 2.204 5.734 3.796h9.848l5.76-3.796 2.829-2.204-8.1 3.649Z"
        />
        <path
          fill="#161616"
          stroke="#161616"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m547.301 609.835-1.242-.91h-7.17l-1.242.91-.647 6.09.595-.606h9.758l.647.606-.699-6.09Z"
        />
        <path
          fill="#763D16"
          stroke="#763D16"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M572.833 579.934 575 569.561l-3.237-9.636-24.522 18.153 9.432 7.957 13.331 3.89 2.957-3.432-1.275-.915 2.039-1.856-1.58-1.22 2.039-1.551-1.351-1.017ZM510 569.561l2.167 10.373-1.377 1.017 2.039 1.551-1.554 1.22 2.039 1.856-1.275.915 2.932 3.432 13.331-3.89 9.431-7.957-24.521-18.153-3.212 9.636Z"
        />
        <path
          fill="#F6851B"
          stroke="#F6851B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m569.581 590.148-13.133-3.877 3.993 6.057-5.951 11.656 7.834-.101H574l-4.419-13.735Zm-41.08-3.877-13.132 3.877L511 603.883h11.651l7.809.101-5.926-11.656 3.967-6.057Zm17.828 6.69.829-14.621 3.816-10.415h-16.948l3.766 10.415.879 14.621.301 4.612.025 11.352h6.956l.05-11.352.326-4.612Z"
        />
        <defs>
          <filter
            id="a"
            width={302}
            height={302}
            x={54}
            y={444.925}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={10} />
            <feGaussianBlur stdDeviation={50} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11090_127722"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_11090_127722"
              result="shape"
            />
          </filter>
          <filter
            id="c"
            width={302}
            height={302}
            x={310}
            y={128.925}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={10} />
            <feGaussianBlur stdDeviation={50} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11090_127722"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_11090_127722"
              result="shape"
            />
          </filter>
          <filter
            id="e"
            width={302}
            height={302}
            x={119}
            y={152.925}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={10} />
            <feGaussianBlur stdDeviation={50} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11090_127722"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_11090_127722"
              result="shape"
            />
          </filter>
          <filter
            id="f"
            width={302}
            height={302}
            x={237}
            y={300.925}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={10} />
            <feGaussianBlur stdDeviation={50} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11090_127722"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_11090_127722"
              result="shape"
            />
          </filter>
          <filter
            id="g"
            width={302}
            height={302}
            x={391}
            y={448.925}
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={10} />
            <feGaussianBlur stdDeviation={50} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11090_127722"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_11090_127722"
              result="shape"
            />
          </filter>
          <clipPath id="b">
            <path fill="#fff" d="M170 549.925h71v71h-71z" />
          </clipPath>
          <clipPath id="d">
            <path fill="#fff" d="M428 245.925h67v58h-67z" />
          </clipPath>
        </defs>
      </svg>
    </React.Fragment>
  )
}


export default LinesComponent
